exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.editNote {\n  text-align: center;\n}\n\ndiv.editNote textarea {\n  width: 90%;\n  height: 9ex;\n  text-align: left;\n  padding: 0.8ex;\n}\n\ndiv.editNote div.buttons {\n  margin-top: 1ex;\n}\n\ndiv.noteHeader {\n  text-align: right;\n  font-style: italic;\n  font-size: small;\n  color:#333;\n}\n\ndiv.noteText {\n  border: thin solid #333;\n  padding:1ex;\n}\n\ndiv.noteButtons {\n  margin-top:0.6ex;\n  text-align: center;\n}\n\ndiv.isOwner {\n  margin:1ex;\n  padding:1ex;\n  border: thick double black;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/note-box/note-box.component.css
// module id = ../../../../../src/app/note-box/note-box.component.css
// module chunks = main